import type { DSData } from 'webapp-types';
import { getIndicatorClass } from 'webapp/utils/number';

import type DsDataOutputCompare from 'webapp/models-custom/ds-data/output/compare';
import DsDataPointWithTs from 'webapp/models-custom/ds-data/point/with-ts';

export default class DsDataPointCompare extends DsDataPointWithTs {
	output: DsDataOutputCompare;

	incomplete: boolean;
	change: number;
	changeStr: string;

	extra: DSData.GoalPointExtraData | null;

	constructor(output: DsDataOutputCompare, rawData: DSData.PointCompare) {
		super(rawData);
		this.output = output;
		this.ts = rawData.ts;
		this.incomplete = !!rawData.incomplete;
		this.change = rawData.change;
		this.changeStr = rawData.changeStr;
		this.extra = (rawData.extra as DSData.GoalPointExtraData) || null; // only for Goal
	}

	get indicatorClass(): string {
		return getIndicatorClass(this.change, this.output.invert);
	}

	get compareSettings() {
		return this.output.compareSettings;
	}
}
